<template>
  <div class="clearfix margin30">
    <el-form-item :label="titleLabel" class="w139">
      <div class="not-border-input">{{ itemTitle.name }}</div>
    </el-form-item>
    <el-form-item :label="isLabel ? $locale('rules.additionalFee') + ' *' : ''" class="w95">
      <el-input v-model="form.price" prefix-icon="el-icon-money"></el-input>
    </el-form-item>
    <el-form-item :label="isLabel ?  $locale('rules.reflectionInBoxOffice') : ''" class="w95">
      <el-select v-model="form.boxOffice">
        <el-option :value="true" :label="$locale('global.yes')"></el-option>
        <el-option :value="false" :label="$locale('global.no')"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="isLabel ? $locale('rules.useOfNationalTickets') + ' *' : ''" class="w95">
      <el-select v-model="form.commonCoupon">
        <el-option
          v-for="item in useTypeOption"
          :label="item.label"
          :value="item.value"
          :key="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="isLabel ? $locale('rules.useTheaterAdvTickets') + ' *' : ''" class="w95">
      <el-select v-model="form.advanceCouponType">
        <el-option
          v-for="item in useTypeOption"
          :label="item.label"
          :value="item.value"
          :key="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="isLabel ? $locale('rules.useInvitationTicket') + ' *' : ''" class="w95">
      <el-select v-model="form.invitationCouponType">
        <el-option
          v-for="item in useTypeOption"
          :label="item.label"
          :value="item.value"
          :key="item.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="isLabel ? `${$locale('rules.revisedEdition')}*` : ''" class="w200">
      <el-select v-model="form.seatsStatus" multiple v-if="componentType == 'seat'" @change="setMultipleCheckAll('seatsStatus')">
        <el-option :label="$locale('rules.allVersion')" :value="'null'" key="null"></el-option>
        <template v-for="item in seatList">
          <el-option
            :label="item.name"
            :value="item.id"
            :key="item.id"
            v-if="item.name != itemTitle.name"
          ></el-option>
        </template>
      </el-select>
      <el-select v-model="form.advanceCouponTypeIds" multiple v-else @change="setMultipleCheckAll('advanceCouponTypeIds')">
        <el-option :label="$locale('rules.allVersion')" :value="'null'" key="null"></el-option>
        <template v-for="item in thisVersionList">
          <el-option
            :label="item.name"
            :value="item.id"
            :key="item.id"
            v-if="item.name != itemTitle.name"
          ></el-option>
        </template>
      </el-select>
    </el-form-item>

    <el-form-item :label="isLabel ? $locale('rules.notAvailableCoupons_multi') : ''" class="w240">
      <RemoteSelectV2
        type="coupon"
        useType="all"
        :list="couponList"
        v-model="form.unCouponTypeIds"
        :formValue.sync="form.unCouponTypeIds"
        :fields="['id', 'name']"
        @selectAll="arr => form.unCouponTypeIds = arr"
        :isSelectAllFunc="true"
        @change="handleChange"
        :isSetFontSize="true"
      />
    </el-form-item>
    <el-form-item :label="isLabel ? $locale('rules.ticketID.forCurrentCinemaLoyalty') : ''" class="w200">
      <el-input v-model="form.couponCode"></el-input>
      <!-- <el-select v-model="form.seatCouponCode" multiple filterable allow-create>
        <el-option v-for="item in couponCodeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select> -->
    </el-form-item>
    <el-form-item :label="isLabel ? '自動適用会員クーポン' : ''" class="w200">
      <!-- <el-input v-model="form.couponId"></el-input> -->
      <RemoteSelectV2
        type="coupon"
        :list="couponList"
        v-model="form.couponId"
        :formValue.sync="form.couponId"
        :isMultiple="false"
        :fields="['id', 'name']"
        @setList="arr => $emit('setList', arr)"
      />
      <!-- <el-select v-model="form.seatCouponCode" multiple filterable allow-create>
        <el-option v-for="item in couponCodeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select> -->
    </el-form-item>
  </div>
</template>

<script>
import MultiSelect from "@/components/common/MultiSelect";
// import RemoteSelect from "@/components/common/RemoteSelect";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
export default {
  name: "ruleTemplatePriceRuleItemModule",
  data() {
    return {
      form: {
        advanceCouponType: "possible",
        boxOffice: true,
        commonCoupon: "possible",
        invitationCouponType: "possible",
        price: 0,
        relationId: "",
        unCouponTypeIds: [],
        couponId: "",
        seatsStatus: null,
        advanceCouponTypeIds: null,
        // ...this.componentType === "seat" ? { seatCouponCode: [] }: {},
        ...this.componentType === "seat" ? { couponCode: "" }: {},
      },
      useTypeOption: [
        {
          label: this.$locale("global.possible"),
          value: "possible",
        },
        {
          label: this.$locale("global.repair"),
          value: "repair",
        },
        {
          label: this.$locale("global.impossible"),
          value: "impossible",
        }
      ],
      seatList: [
        {
          id: "vip",
          name: this.$locale("theatre.seat.vip"),
        },
        {
          id: "special",
          name: this.$locale("theatre.seat.special"),
        },
        {
          id: "general",
          name: this.$locale("theatre.seat.general"),
        },
        {
          id: "wheelchair",
          name: this.$locale("theatre.seat.wheelchair"),
        },
        {
          id: "lovers",
          name: this.$locale("theatre.seat.loversSeat"),
        },
        {
          id: "posCounter",
          name: this.$locale("theatre.seat.windowSeat"),
        },
      ],
      thisVersionList: [],
      comCouponList: []
    };
  },
  // computed: {
  //   couponCodeList() {
  //     return this.form.seatCouponCode ? this.form.seatCouponCode.map(str => ({
  //       label: str,
  //       value: str
  //     })) : [];
  //   }
  // },
  methods: {
    setMultipleCheckAll(keyName) {
      let arr = [ "null" ];

      if (this.form[keyName].indexOf("null") >= 0) {
        this.form[keyName] = [ ...arr ];
      }
    },
    initForm() {
      let form = { ...this.form, ...this.formObj };
      let thisVersionList = [];
      let hasApprove = "";

      if (this.versionList.length > 0) {
        hasApprove = "approve" in this.versionList[this.versionIndex];
      }

      if (!form.seatsStatus || (form.seatsStatus instanceof Array && form.seatsStatus.length == 0)) {
        form.seatsStatus = [ "null" ];
      }

      if (!form.advanceCouponTypeIds || (form.advanceCouponTypeIds instanceof Array && form.advanceCouponTypeIds.length == 0)) {
        form.advanceCouponTypeIds = [ "null" ];
      }

      this.versionList.map(item => {
        if ("approve" in item == hasApprove) {
          thisVersionList.push({ ...item });
        }
      });

      this.thisVersionList = thisVersionList;
      this.form = form;
    },
    handleChange(value) {
      if (value.includes("all")) {
        this.form.unCouponTypeIds = ['all'];
      }
    },
  },
  mounted() {
    this.initForm();
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
    itemTitle: {
      type: Object,
      default: () => ({ id: "", name: "" }),
    },
    isLabel: {
      type: Boolean,
      default: true,
    },
    couponTypeList: {
      type: Array,
      default: () => [],
    },
    titleLabel: {
      type: String,
      default: "",
    },
    componentType: {
      type: String,
      default: "seat",
    },
    versionList: {
      type: Array,
      default: () => [],
    },
    versionIndex: {
      type: Number,
      default: () => 0,
    },
    formName: {
      type: String,
      default: "",
    },
    couponList: {
      type: Array,
      default: () => [],
    }
  },
  components: {
    MultiSelect,
    // RemoteSelect
    RemoteSelectV2
  },
  watch: {
    formObj() {
      this.initForm();
    },
    injectCouponList(val) {
      if (val.length > 0) {
        this.comCouponList = val
      }
    }
  },
};
</script>
